<template>
  <div v-loading="loading">
    <el-form ref="form" :model="form" label-width="250px" @submit.prevent="onSubmit"
      style="margin: 20px; width: 60%; min-width: 600px">
      <el-form-item label="Low Limit (%)">
        <el-input v-model="form.lowLimit" type="number" step="1"></el-input>
      </el-form-item>
      <el-form-item label="High Limit (%)">
        <el-input v-model="form.highLimit" type="number"></el-input>
      </el-form-item>
      <el-form-item label="Valve Speed (% / Minute)" style="margin-top: 30px">
        <el-input v-model="form.valveSetSpeed" type="number" min="0" max="10"></el-input>
      </el-form-item>
      <el-form-item label="Low Pressure Close">
        <el-checkbox v-model="form.lowPressureClose.enabled" @change="enabledCheckboxChange"></el-checkbox>
      </el-form-item>
      <el-form-item label="Low Pressure Setpoint (PSI)">
        <el-input v-model="form.lowPressureClose.setPoint" @focus="lowPressureCloseSetPointFocus"></el-input>
      </el-form-item>
      <el-form-item style="margin-top: 10px">
        <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
      </el-form-item>

      <input style="color: white; outline: none; border: none" ref="hidden" />
    </el-form>
  </div>
</template>

<script>
import Axios from "axios"
import echarts from "echarts"
import IOService from "@/api/io.service"
import SettingsService from "@/api/settings.service"
import constants from "@/common/constants/system"

export default {
  data() {
    return {
      loading: false,
      form: {
        lowLimit: "",
        highLimit: "",
        valveSetSpeed: "",
        lowPressureClose: {
          enabled: false,
          setPoint: ""
        }
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    verifySettings() {
      if (isNaN(parseInt(this.form.lowLimit)) || parseInt(this.form.lowLimit) < 0 || parseInt(this.form.lowLimit) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "Low Limit",
          message: "Value not valid.  Value should be between 0 and 100",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.highLimit)) || parseInt(this.form.highLimit) < 0 || parseInt(this.form.highLimit) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "High Limit",
          message: "Value not valid.  Value should be between 0 and 100",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.valveSetSpeed)) || parseInt(this.form.valveSetSpeed) < 0 || parseInt(this.form.valveSetSpeed) > 10) {
        const h = this.$createElement
        this.$notify({
          title: "Valve Set Speed",
          message: "Value not valid.  Value should be between 0 and 10",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.lowPressureClose.setPoint)) || parseInt(this.form.lowPressureClose.setPoint) < 0 || parseInt(this.form.lowPressureClose.setPoint) > 20) {
        const h = this.$createElement
        this.$notify({
          title: "Low Pressure Close",
          message: "Value not valid.  Value should be between 0 and 20",
          type: "error"
        })
        return false
      }

      return true
    },
    saveDataToPanel() {
      if (!this.verifySettings()) return
      this.loading = true
      Axios.all([
        SettingsService.changeSetting(this.user.activeZone, "Settings.Motor.Limit.Low", this.form.lowLimit),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Motor.Limit.High", this.form.highLimit),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Motor.Speed.ValveSet", this.form.valveSetSpeed),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Motor.LowPressureClose.Enabled", this.form.lowPressureClose.enabled ? "true" : "false"),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Motor.LowPressureClose.SetPoint", this.form.lowPressureClose.setPoint)
      ])
        .then(
          Axios.spread((lowLimitResponse, highLimitResponse, valveSetSpeedResponse) => {
            //The system should update in 10 seconds.
            this.loading = false
            if (lowLimitResponse.data.result != "success" || highLimitResponse.data.result != "success" || valveSetSpeedResponse.data.result != "success") {
              const h = this.$createElement
              this.$notify({
                title: "Valve Settings",
                message: "Error trying to save data to panel",
                type: "error"
              })
            } else {
              this.$notify({
                title: "Valve",
                message: "Settings Saved to Panel",
                type: "info"
              })
            }
          })
        )
        .catch(() => {
          this.loading = false
          const h = this.$createElement
          this.$notify({
            title: "Motor Settings",
            message: "Error trying to save data to panel",
            type: "error"
          })
        })
    },
    getData() {
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([IOService.getSettings(this.user.activeZone)]).then(
        Axios.spread((settingsResponse) => {
          this.form.lowLimit = settingsResponse.data.motor.limit.low
          this.form.highLimit = settingsResponse.data.motor.limit.high
          this.form.valveSetSpeed = settingsResponse.data.motor.speed.valveSet
          this.form.lowPressureClose.enabled = settingsResponse.data.motor.lowPressureClose.enabled == "true"
          this.form.lowPressureClose.setPoint = settingsResponse.data.motor.lowPressureClose.setPoint
        })
      )
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}

/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// Motor.vue?16a22f07